import * as Yup from 'yup';

export const ProfileSettingSchema = Yup.object({
  name: Yup.string()
    .min(3, "Name must be at least 3 characters")
    .required("Please enter your name"),

  password: Yup.string()
    .required("Password is a required field")
    .test('password-strength', 'Password does not meet the criteria', function (value) {
      let errors = [];

      if (!/^(?=.{8,})/.test(value)) {
        errors.push("8 Characters Minimum");
      }
      if (/^(?=.{17,})/.test(value)) {
        errors.push("16 Characters Maximum");
      }

      if (!/(?=.*[!@#$%^&*])/.test(value)) {
        errors.push("One Special Character");
      }

      if (!/(?=.*[0-9])/.test(value)) {
        errors.push("One Number");
      }

      if (!/(?=.*[a-z])/.test(value)) {
        errors.push("One Lowercase Character");
      }

      if (!/(?=.*[A-Z])/.test(value)) {
        errors.push("One Uppercase Character");
      }

      // if (errors.length > 0) {
      //   return this.createError({
      //     path: 'password',
      //     message: errors.join(', '), // Join errors into a single string
      //   });
      // }

      if (errors.length > 0) {
        throw new Yup.ValidationError({
          errors: errors,
          inner: true,
          path: "password",
          message: errors,
          value: value,
          name: "ValidationError",
        });
      }

      return true;
    }),

  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref('password'), null], "Passwords must match"),
});
